import { render } from "./modificationUseronfo.vue?vue&type=template&id=884114f0&scoped=true"
import script from "./modificationUseronfo.vue?vue&type=script&lang=js"
export * from "./modificationUseronfo.vue?vue&type=script&lang=js"

import "./modificationUseronfo.vue?vue&type=style&index=0&id=884114f0&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884114f0"]])

export default __exports__